import Link from 'next/link';
import { useRouter } from 'next/router';

import { Colors } from '../components/general';
import Navbar from '../components/navbar';
import Page, { Content } from '../components/page';

const About: React.FC = () => {
  const router = useRouter();

  return (
    <Page className="bg-gray-100">
      <Navbar showDismiss onAction={() => router.push('/feed')} />

      <Content>
        <div className="mx-4 mt-8 mb-8 lg:mb-12 flex flex-col">
          <p className={`font-semibold text-3xl text-${Colors.black}`}>FAQ</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Is this for real?</p>
          <p className={`mt-1 text-${Colors.black}`}>Yes.</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Like, actually?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            Yes. We are fully operational in New York City and Los Angeles (for a limited time only).
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>How does it work?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            You use your number to create an account (don&apos;t worry — we won&apos;t spam you). You&apos;ll then
            select the type of relationship you were a part of, add the items you&apos;d like to get back/send, and fill
            out some delivery info (your address, your ex&apos;s phone number, payment method, etc). Depending on the
            situation, we&apos;ll reach out to your ex (or whoever) to see if they either A) have your items and are
            willing to let us come pick then up or B) are willing to accept the delivery for the items that you&apos;re
            returning to them. If yes, then we&apos;ll proceed with the delivery! You pay only after your request is
            accepted. Check out our{' '}
            <Link href="/how-to">
              <span className="text-pink-400 font-medium cursor-pointer">How to Postdate</span>
            </Link>{' '}
            page for a step-by-step breakdown.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            IDK where my ex lives. Do I need their address?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>No! Just their cell number so we can text them.</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Will I be charged?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            You will <span className="font-medium">only</span> be charged if you choose to complete the order, which
            happens <span className="italic">after</span> we reach out to your ex and you agree to the final delivery
            fee.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Why did you do this?</p>
          <p className={`mt-1 text-${Colors.black}`}>Beacuse no one else did?</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Can I just browse the site?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            Yes, of course! We&apos;ll only ask you to verify your address and add a payment method at the end of
            checkout.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            What <span className="italic">happened</span> to you?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>Bad breakups!</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Who made this?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            <a
              href="https://twitter.com/atlasacopian"
              target="_blank"
              rel="noreferrer"
              className="text-pink-400 font-medium"
            >
              Atlas Acopian
            </a>
            ,{' '}
            <a
              href="https://twitter.com/suzyshinn"
              target="_blank"
              rel="noreferrer"
              className="text-pink-400 font-medium"
            >
              Suzy Shinn
            </a>
            , and{' '}
            <a href="https://twitter.com/bhwags" target="_blank" rel="noreferrer" className="text-pink-400 font-medium">
              Brian Wagner
            </a>
            .
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            Can you break up with my girlfriend/boyfriend/wife/husband for me?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>Please do not make us do this.</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            My delivery is taking longer than expected or never arrived. Help?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>
            If you have an active order, please respond to the initial text that was sent to you.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>What can I Postdate?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            Almost* anything that fits in a large grocery bag (12x7x17&quot;).
          </p>
          <p className={`mt-1 text-${Colors.black}`}>*Please see below for prohibited items.</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            Does Postdates deliver alcohol, livestock, drugs, weapons, and/or illegal substances?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>
            NO, WE DO NOT. Do not put in a request to transport these types of items. Your order will be cancelled
            immediately and if necessary, punishable by law. For example, we will not transport a pet fish, dog, cat,
            gun, meth, H, bow &amp; arrow, nuclear matter, wine (unopened/opened), weed, and/or anything else
            questionable.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            Can Postdates go to multiple locations within one delivery?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>
            Unfortunately, no. However, Postdates does not limit you from placing multiple orders at the same time,
            though, in the event you need items from multiple locations.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>When will my order arrive?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            In short, within 24 hours if your ex (or whoever) accepts the request. BTW, our hours of operation are from
            9AM-1PM in Monday through Friday in NY (with limited availability on the weekends) and 11AM-8PM 7 days a
            week in LA, so expect it to happen at a &quot;normal&quot; time.
          </p>
          <p className={`mt-2 text-${Colors.black}`}>
            Once we text your ex (or whoever), they will have 12 hours to respond to let us know 1) if they&apos;re
            willing to work with Postdates and 2) when they are available. They will then select a pickup time for
            either the same or next day. We will notify you of the time selection when you confirm your order.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>How do I tip my Postdates drivers?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            When confirming payment, a pre-paid tip suggestion will be located at the bottom of your screen.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Can we tip the creators of Postdates?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            Actually, yes. Venmo @katyperry (seriously) and we will distribute it among the three of us who have spent
            thousands of dollars and hours to make Postdates happen 🥴.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            Wait, what are you going to say to my ex?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>
            We&apos;ll generate an automated text that you&apos;ll get to preview before your order is submitted.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>
            My final total was different than expected. Why?
          </p>
          <p className={`mt-1 text-${Colors.black}`}>
            We will calculate your order based on a flat rate plus distance between you and the person you&apos;re
            sending/requesting items from. There are additional fees for inconveniences such as overweight items tolls,
            no show orders, providing the wrong address, etc. See our{' '}
            <Link href="/terms">
              <span className="text-pink-400 font-medium cursor-pointer">Terms</span>
            </Link>{' '}
            for details.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>How will I get a receipt for my order?</p>
          <p className={`mt-1 text-${Colors.black}`}>We will email you a receipt.</p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>What&apos;s your refund policy?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            All services rendered by Postdates are provided on a non-refundable and non-creditable basis. Once your
            delivery has started, Postdates will be unable to issue any refunds.
          </p>

          <p className={`mt-8 font-semibold text-2xl text-${Colors.black}`}>Is Postdates COVID safe?</p>
          <p className={`mt-1 text-${Colors.black}`}>
            We are doing our best to ensure all of our deliveries are 100% contact free.
          </p>
        </div>
      </Content>
    </Page>
  );
};

export default About;
